import axios from "axios";

const users_cache = {};

const users = {
    async bulk(params = {}){
        return (await axios.get('/api/user/bulk', {params})).data;
    },

    async getCached(id){
        if( typeof users_cache[id] !== 'undefined' ) return users_cache[id];
        const users = await this.bulk({ids: [id]});
        if( !users.length ) return null;
        return users_cache[id] = users[0];
    },

    async update(user_id, changes){
        return (await axios.put(`/api/user/${user_id}`, changes)).data;
    }

}

export default users;
